"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drop = exports.add = exports.DROP = exports.ADD = void 0;
exports.ADD = "notification/add";
exports.DROP = "notification/drop";
var add = function (body, now) { return ({
    type: exports.ADD,
    payload: { body: body, now: now },
}); };
exports.add = add;
var drop = function (id, now) { return ({
    type: exports.DROP,
    payload: { id: id, now: now },
}); };
exports.drop = drop;
